import React, {Component} from 'react';
import DropZone from "react-drop-zone";
import { DropTarget } from 'react-drag-drop-container';
import "./Pulpit.css";

export class Pulpit extends Component {
    constructor(props) {
        super(props);

        this.state = {
            src:'',
            history:['']
        };
    }
    allowedExtensions = (src) => {
        const allowedExtensions =
            /(\.jpg|\.jpeg|\.png|\.gif|\.svg)(|\?.*)$/i;
        const prevent = (allowedExtensions.exec(src)?false:true);
        return prevent;
    }

    drop = (event) => {
        event.preventDefault();
        let src = event.dataTransfer.getData('application/x-moz-file-promise-url');
        if(!src)
            src = event.dataTransfer.getData('text/plain');
        if(src) {
            if ( this.allowedExtensions(src) ) {
                return;
            } else {
                this.setState({
                    src:src
                });
            }
        }
    }

    responseDrop = ({ dragData: { src, name }}) => {
        this.setState({
            src:src
        });
    }


    render() {
        return (
            <div id="Pulpit"
                 onDrop={this.drop}
            >
                <DropTarget
                    onHit={this.responseDrop}
                >
                    <DropZone
                    onDrop={(file) =>{file.src = URL.createObjectURL(file); this.responseDrop(file, false) }}
                    handleClick={ false }
                    >
                        { () => (
                            <div className='container3d'>
                            <div className='DropZone box3d'>
                                <img src={this.state.src} alt='upuść Mape/ Obrazek tutaj...' className='contenderElement' />
                            </div>
                            </div>
                            )}
                    </DropZone>
                </DropTarget>
            </div>
        )
    }
}